import styled from '@emotion/styled'
import { gsColors } from '../../../styles/Variables'
import { mq } from '../../../helpers'

export const HowItWorksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  overflow-x: clip;
`

// Overrides the shared <Hero> for the how-it-works page.
// Default Hero layout is correct (content left, image right).
// We change: bg color salmon, text color cobalt, large centered text.
export const HeroOverride = styled.div`
  width: 100%;

  .hero-container-inner {
    height: auto !important;
  }

  .content {
    background-color: ${gsColors.salmon} !important;
    height: auto !important;
    align-self: stretch !important;

    ${mq('max', '768px')} {
      min-height: 418px !important;
    }
  }

  .content .inner {
    text-align: center !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 88px !important;

    ${mq('max', '1290px')} {
      margin: 0 40px !important;
    }

    ${mq('max', '768px')} {
      margin: 0 16px !important;
    }

    h1 {
      color: ${gsColors.cobalt} !important;
      text-align: center !important;
      text-transform: uppercase !important;
      font-size: 82px !important;
      line-height: 1.08 !important;
      letter-spacing: 1.64px !important;
      width: 100% !important;

      ${mq('max', '1290px')} {
        font-size: 72px !important;
      }

      ${mq('max', '1024px')} {
        font-size: 64px !important;
        letter-spacing: 1.28px !important;
      }

      ${mq('max', '768px')} {
        font-size: 56px !important;
        line-height: 1.1 !important;
        letter-spacing: 1.12px !important;
      }

      ${mq('max', '480px')} {
        font-size: 48px !important;
        line-height: 1.05 !important;
        letter-spacing: 0.96px !important;
      }
    }
  }

  .image-placeholder {
    height: auto !important;
    min-height: 0 !important;
    aspect-ratio: 720 / 748;
  }
`
